import { __rest } from "tslib";
import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { ScrollArea, Separator } from "@skve/components"
 *
 * const tags = Array.from({ length: 50 }).map(
 *   (_, i, a) => `v1.2.0-beta.${a.length - i}`
 * )
 *
 * function Demo() {
 *   return (
 *     <ScrollArea className="h-72 w-48 rounded-md border">
 *       <div className="p-4">
 *         <h4 className="mb-4 text-sm font-medium leading-none">Tags</h4>
 *         {tags.map((tag) => (
 *           <>
 *             <div key={tag} className="text-sm">
 *               {tag}
 *             </div>
 *             <Separator className="my-2" />
 *           </>
 *         ))}
 *       </div>
 *     </ScrollArea>
 *   )
 * }
 * ```
 */
const ScrollArea = React.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(ScrollAreaPrimitive.Root, Object.assign({ ref: ref, className: cn("relative overflow-hidden", className) }, props),
        React.createElement(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]" }, children),
        React.createElement(ScrollBar, null),
        React.createElement(ScrollAreaPrimitive.Corner, null)));
});
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
const ScrollBar = React.forwardRef((_a, ref) => {
    var { className, orientation = "vertical" } = _a, props = __rest(_a, ["className", "orientation"]);
    return (React.createElement(ScrollAreaPrimitive.ScrollAreaScrollbar, Object.assign({ ref: ref, orientation: orientation, className: cn("flex touch-none select-none transition-colors", orientation === "vertical" &&
            "h-full w-2.5 border-l border-l-transparent p-[1px]", orientation === "horizontal" &&
            "h-2.5 flex-col border-t border-t-transparent p-[1px]", className) }, props),
        React.createElement(ScrollAreaPrimitive.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })));
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export { ScrollArea, ScrollBar };
//# sourceMappingURL=scroll-area.js.map